import queries, { breakpoints } from 'styles/breakpoints'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AnimatePresence } from 'framer-motion'

import { ReactComponent as IconView } from 'assets/shared/icon-view-image.svg'
import {
  currentSlideIndex,
  currentSlide,
  slidesDirection,
} from 'store/slidesSlice'
import { openLightBox } from 'store/lightboxSlice'
import {
  Article,
  Button,
  Body,
  Caption,
  Description,
  Figure,
  Header,
  Link,
} from './Slide.styles'
import { slideAnimation } from 'utils/animations'

const Slide = (): JSX.Element => {
  const currentIndex = useSelector(currentSlideIndex)
  const direction = useSelector(slidesDirection)
  const current = useSelector(currentSlide)
  const dispatch = useDispatch()
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  useEffect(() => {
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  })

  return (
    <AnimatePresence initial={false} custom={direction}>
      <Article
        key={currentIndex}
        custom={direction}
        variants={slideAnimation}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{
          duration: 0.5,
          ease: 'easeInOut',
        }}
      >
        <Header>
          <Figure
            isPortait={current.isPortrait}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
          >
            <picture>
              <source
                media={queries.tabletUp}
                srcSet={current.images.hero.large}
              />
              <img src={current.images.hero.small} alt="" />
            </picture>

            <Button onClick={() => dispatch(openLightBox())}>
              <IconView />
              <span>View image</span>
            </Button>
          </Figure>
        </Header>
        <Body year={current.year} isPortrait={current.isPortrait}>
          {windowDimensions.width <= breakpoints.tabletMin ? (
            <></>
          ) : (
            <Caption>
              <h2>{current.name}</h2>
              <p>{current.artist}</p>
            </Caption>
          )}

          <Description>{current.description}</Description>
          <Link href={current.source} target="_blank" rel="noopener noreferrer">
            Go to source
          </Link>
        </Body>
      </Article>
    </AnimatePresence>
  )
}

export default Slide
